import PaymentInfoBlock, { PaymentInfoBlockProps } from './PaymentInfoBlock';

import withInteractor from './PaymentInfoBlock.interactor';
import withPresenter from './PaymentInfoBlock.presenter';

export type { PaymentInfoBlockProps };
export default withInteractor(withPresenter(PaymentInfoBlock));
